import React from "react";
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";

// Helpers

const index = () => {
	return (
		<Card>
			<CardHeader>
				<Row>
					<Col><h3>Drawing Office</h3></Col>
				</Row>
			</CardHeader>

			<CardBody>
				Drawing Office Index
			</CardBody>
		</Card>
	)
}

export default index

